// MissionImages.jsx - Updated with static grid layout (no sliding)
import React, { useState } from "react";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Instagram from "../../api/Instagram";
import './inasta.css'

const MissionImages = (props) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");

    const openModal = (image) => {
        setSelectedImage(image);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };


    // Use mission gallery if available, otherwise fall back to Instagram
    // Add title/subtitle if available (like gallery.js)
    // Show up to 8 images in a 3-row, 4-column grid
    const imagesToDisplay = props.mission && props.mission.gallery && props.mission.gallery.length > 0
        ? props.mission.gallery.slice(0, 6).map((img, idx) => ({ id: idx.toString(), imag: img, title: '', subtitle: '' }))
        : Instagram.slice(0, 8);


    // Assign mosaic area classes for first 12 images (like GallerySection)
    const getAreaClass = (idx) => idx < 8 ? `area-${idx + 1}` : '';

    return (
        <section className={props.hclass ? props.hclass + ' wpo-instagram-section s2 section-padding' : 'wpo-instagram-section s2 section-padding'}>
            <div className="container">
                <div className="gallery-gri mission-gallery-grid">
                    {imagesToDisplay.map((item, idx) => (
                        <div className={`gallery-item ${getAreaClass(idx)}`} key={item.id}>
                            <div className="instagram-card">
                                <div className="" >
                                    <img
                                        src={item.imag}
                                        alt={`Gallery item ${item.id}`}
                                        className="gallery-image"
                                        loading="lazy"
                                    />
                                   
                                </div>
                                {/* Show title/subtitle if available */}
                                {(item.title || item.subtitle) && (
                                    <div className="text">
                                        {item.title && <span>{item.title}</span>}
                                        {item.subtitle && <h2>{item.subtitle}</h2>}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Lightbox Modal */}
            {modalOpen && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close" onClick={closeModal}>
                            &times;
                        </button>
                        <img src={selectedImage} alt="Full size" className="modal-image" />
                    </div>
                </div>
            )}
        </section>
    );
};

export default MissionImages;